import { useState } from 'react'
import { FiChevronDown } from 'react-icons/fi'
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuList,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react'

import { ActiveOrders } from 'components/Orders'
import { RecentTransactions } from 'components/Transactions'

const ActivityButton = () => {
  const [tabIndex, setTabIndex] = useState<number>(0)

  const handleTabsChange = (index: number) => {
    setTabIndex(index)
  }

  return (
    <Menu>
      {({ isOpen }) => (
        <>
          <MenuButton
            isActive={isOpen}
            as={Button}
            rightIcon={<FiChevronDown />}
            h={12}
            bg={'dimmed'}
            border={'2px solid rgba(255,255,255,0.1)'}
            borderRadius={'xl'}
            color={'white'}
            fontFamily={'mono'}
            fontSize={'14px'}
            _hover={{ opacity: 0.8 }}
            _active={{ opacity: 0.8 }}
            _focus={{
              bg: 'dimmed',
            }}
          >
            Activity
          </MenuButton>
          <MenuList
            right={{ base: '-15.5rem', md: '-19.5rem' }}
            minW={'fit-content'}
            w={{ base: '22.5rem', md: '30rem' }}
            pos={'absolute'}
            h={'30rem'}
            zIndex={999}
            bg={'dark'}
            border={'2px solid'}
            borderColor={'mid'}
            borderRadius={'2xl'}
            p={2}
          >
            <Tabs
              isLazy
              tabIndex={tabIndex}
              onChange={handleTabsChange}
              lazyBehavior="unmount"
            >
              <TabList borderBottom={'none'}>
                <Tab
                  px={8}
                  w={'50%'}
                  p={4}
                  fontSize={'sm'}
                  fontWeight={500}
                  border={'1px solid rgba(255, 255, 255, 0.1)'}
                  borderRadius={'12px 0 0 12px'}
                  color={'gray.500'}
                  pos={'relative'}
                  overflow={'hidden'}
                  _selected={{
                    color: 'white',
                    background: '#1F2546',
                  }}
                  _focus={{ boxShadow: 'none' }}
                >
                  Orders
                  {tabIndex === 0 && (
                    <Box
                      bg={'linear-gradient(90deg, #467EE5, #FF4E70)'}
                      pos={'absolute'}
                      left={0}
                      right={0}
                      bottom={0}
                      h={'4px'}
                      border={'none'}
                      borderBottomLeftRadius={'2xl'}
                    />
                  )}
                </Tab>
                <Tab
                  px={8}
                  w={'50%'}
                  p={4}
                  fontWeight={500}
                  fontSize={'sm'}
                  border={'1px solid rgba(255, 255, 255, 0.1)'}
                  borderRadius={'0 12px 12px 0'}
                  color={'gray.500'}
                  pos={'relative'}
                  overflow={'hidden'}
                  _selected={{
                    color: 'white',
                    background: '#1F2546',
                  }}
                  _focus={{ boxShadow: 'none' }}
                >
                  Transactions
                  {tabIndex === 1 && (
                    <Box
                      bg={'linear-gradient(90deg, #467EE5, #FF4E70)'}
                      pos={'absolute'}
                      left={0}
                      right={0}
                      bottom={0}
                      h={'4px'}
                      border={'none'}
                      borderBottomRightRadius={'2xl'}
                    />
                  )}
                </Tab>
              </TabList>
              <TabPanels my={'auto'} pos={'relative'}>
                <TabPanel>
                  <ActiveOrders isOpen={isOpen} />
                </TabPanel>
                <TabPanel>
                  <RecentTransactions />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </MenuList>
        </>
      )}
    </Menu>
  )
}

export default ActivityButton
